module.exports = __webpack_public_path__ + "static/media/1656587769_55-illustration_png.f6e1fb34.png";